import { render, staticRenderFns } from "./incomeList.vue?vue&type=template&id=bf0bab70"
import script from "./incomeList.vue?vue&type=script&lang=js"
export * from "./incomeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports